import { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { trackEvent } from '../utils/monitoring/posthog';
import { MonitoringEventTypes } from '../utils/monitoring/Monitoring_Events_Enum';
import { usePostHog } from 'posthog-js/react';
import { useSelector } from 'react-redux';
import { update } from '@intercom/messenger-js-sdk';
import { shouldHideIntercomLauncher } from '../utils/intercomLauncher';

const RouteChangeTracker = () => {
  const history = useHistory();
  const location = useLocation();
  const { user } = useSelector((state: any) => state.user);
  const prevLocation = useRef(location.pathname); // Track previous location to prevent redundant tracking
  const posthog = usePostHog();

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== prevLocation.current) {
        trackEvent(posthog, MonitoringEventTypes.NAVIGATION_PAGE_VIEWED, {
          page: location.pathname, // Current page
          previousPage: prevLocation.current, // Previous page
          timestamp: new Date().toISOString(), // Time of the pageview
          userId: user._id, // ID of the user navigating
          referrer: document.referrer, // Referrer URL
          queryParams: location.search, // Query params, like '?storeId=123'
          pageTitle: document.title // Title of the page being viewed
        });
        // Update previous location
        prevLocation.current = location.pathname;
      }
    });
    return () => {
      unlisten(); // Cleanup listener on component unmount
    };
  }, []);

  useEffect(() => {
    // Keep the launcher unobtrusive on order-flow pages and restore it everywhere else.
    update({
      hide_default_launcher: shouldHideIntercomLauncher(location.pathname),
    });
  }, [location.pathname]);

  return <div></div>;
};

export default RouteChangeTracker;
